/* Recently viewed (sections/pl-recent): the shopper's trail of product pages, newest first, in localStorage
   'pl-recent'. Every product page records itself; the rail shows the products seen before this one, as the same
   cards as every rail (sections/pl-card-solo through the Section Rendering API). Cards load when the rail is
   near the screen (or scrolled past) and are kept for 15 minutes in sessionStorage. A product that no longer opens drops off the trail.
   Counts fill rows: 8 or 4, else 2 or 3 centred; phones drop an odd last card. */
(() => {
  const KEY = 'pl-recent';
  const KEEP = 16;
  const TTL = 15 * 60 * 1000;
  const box = document.querySelector('[data-pl-recent]');
  if (!box) return;
  const here = box.dataset.handle;
  const limit = parseInt(box.dataset.limit, 10) || 8;

  const read = () => {
    try {
      const a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a.filter((h) => typeof h === 'string' && h) : [];
    } catch (e) {
      return [];
    }
  };
  const write = (a) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(a.slice(0, KEEP)));
    } catch (e) { /* private mode or full: the rail just stays empty */ }
  };

  const before = read();
  if (here) write([here, ...before.filter((h) => h !== here)]);

  // never repeat this product or the "Pairs with" rail
  const skip = new Set([here]);
  document.querySelectorAll('[data-pl-pairs] .pl-card__link[href]').forEach((a) => {
    const m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (m) skip.add(decodeURIComponent(m[1]));
  });
  const want = before.filter((h) => !skip.has(h)).slice(0, limit);
  if (want.length < 2) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cacheKey = (h) => `pl-recent-card:${h}`;
  const cached = (h) => {
    try {
      const c = JSON.parse(sessionStorage.getItem(cacheKey(h)) || 'null');
      return c && Date.now() - c.at < TTL ? c.html : null;
    } catch (e) {
      return null;
    }
  };
  const remember = (h, html) => {
    try {
      sessionStorage.setItem(cacheKey(h), JSON.stringify({at: Date.now(), html}));
    } catch (e) { /* ignore */ }
  };

  const card = (h) => {
    const hit = cached(h);
    if (hit) return Promise.resolve(hit);
    return fetch(`${root}products/${encodeURIComponent(h)}?section_id=pl-card-solo`, {credentials: 'same-origin'})
      .then((r) => (r.ok ? r.text() : null))
      .then((html) => {
        if (html === null) return null;
        const t = document.createElement('template');
        t.innerHTML = html;
        const el = t.content.querySelector('.pl-card');
        const out = el ? el.outerHTML : '';
        remember(h, out);
        return out;
      })
      .catch(() => '');
  };

  const fill = () => {
    Promise.all(want.map(card)).then((cards) => {
      // null = the product page is gone (404): drop it from the trail; '' = a network hiccup: keep it
      const gone = want.filter((h, i) => cards[i] === null);
      if (gone.length) write(read().filter((h) => !gone.includes(h)));
      let list = cards.filter(Boolean);
      if (list.length < 2) return;
      if (list.length >= 8 && limit >= 8) list = list.slice(0, 8);
      else if (list.length >= 4) list = list.slice(0, 4);
      const rail = box.querySelector('[data-pl-recent-list]');
      rail.innerHTML = list.join('');
      box.classList.toggle('pl-recent--few', list.length < 4);
      box.classList.toggle('pl-recent--odd', list.length % 2 === 1);
      box.style.setProperty('--pl-rc', String(Math.min(list.length, 4)));
      box.hidden = false;
    });
  };

  // load once the rail's spot is within 800px of the screen, or already passed: a jump to the page end (End key, a
  // fast fling) never crosses the spot, so an IntersectionObserver alone missed it
  const spot = box.parentElement || box;
  let started = false;
  const go = () => {
    if (started || spot.getBoundingClientRect().top > window.innerHeight + 800) return;
    started = true;
    window.removeEventListener('scroll', go);
    fill();
  };
  window.addEventListener('scroll', go, {passive: true});
  go();
})();
